import { render, staticRenderFns } from "./ExternalSftpConfigurationView.vue?vue&type=template&id=7fee15be&lang=pug&"
import script from "./ExternalSftpConfigurationView.vue?vue&type=script&lang=ts&"
export * from "./ExternalSftpConfigurationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports